/**
 * AJAX で追加されたコンテンツに FONTPLUS のフォントを再適用する。
 * 各 load-more スクリプトが `danc:events-loaded` を dispatch する想定。
 */
document.addEventListener('danc:events-loaded', function () {
  if (typeof window.FONTPLUS !== 'undefined' && typeof window.FONTPLUS.reload === 'function') {
    window.FONTPLUS.reload();
  }
});
